export default {
  title: 'Tip',
  description: 'Click on the product name to view detailed information and allergens!',
};
